import React from 'react';
import PropTypes from 'prop-types';

import SplitText from '../SplitText';

const ViewMessage = ({ content }) => {
  return <SplitText>{content.text}</SplitText>;
};

ViewMessage.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string.isRequired
  }).isRequired
};

export default ViewMessage;
